import React from "react";
import {
  ArrowUpTrayIcon,
  DocumentTextIcon,
  FolderIcon,
} from "@heroicons/react/24/outline";
import { BucketObject } from "@via/pages/data/data-sources/utils/helpers.tsx";
import { classNames } from "@via/utils/helpers.tsx";

interface FileRowProps {
  item: BucketObject;
  checked: boolean;
  disabled: boolean;
  onToggle: () => void;
  onClick: () => void;
}

const FileRow: React.FC<FileRowProps> = ({
  item,
  checked,
  disabled,
  onToggle,
  onClick,
}) => {
  const icon =
    item.id === ".." ? (
      <ArrowUpTrayIcon className="h-5 w-5 text-gray-700" />
    ) : item.type === "folder" ? (
      <FolderIcon className="h-6 w-6 text-gray-700" />
    ) : (
      <DocumentTextIcon className="h-6 w-6 text-gray-700" />
    );

  return (
    <div
      data-testid={`itemSelection-${item.name}`}
      className={classNames(
        item.type === "folder" ? "cursor-pointer" : "",
        "flex items-center gap-4 px-4 py-3 hover:bg-gray-50"
      )}>
      <input
        type="checkbox"
        className="h-4 w-4 rounded border-gray-500 text-indigo-600 focus:ring-indigo-600 disabled:cursor-not-allowed"
        checked={checked}
        onChange={onToggle}
        disabled={disabled}
      />

      <div className="flex items-center" onClick={onClick}>
        {icon}
      </div>

      <div className="flex min-w-0 flex-1 flex-col" onClick={onClick}>
        <div className="font-medium text-sm text-gray-900">
          {item.displayName}
        </div>
        {item.path ? (
          <div className="text-sm text-gray-500">{item.path}</div>
        ) : null}
      </div>
    </div>
  );
};

export default FileRow;
